export const LIGHT_THEME_BACKGROUND = "#FFFFFF";

export const DARK_THEME_BACKGROUND = "#464646";
